import React, { useEffect, useState } from "react";
import styles from "./JobDetails.module.scss";
import { getJobDetails } from "service/formService";
import { useHistory } from "react-router";
import Loader from "../Loader/Loader";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import { markCareersReferral } from "util/library";

function expRangeString(minExp, maxExp) {
  // Check if only one of the exp is present
  if (minExp !== null && maxExp === null) {
    return minExp + " years";
  }

  if (minExp === null && maxExp !== null) {
    return maxExp + " years";
  }

  if (minExp === null && maxExp === null) {
    return "";
  }

  return minExp + " - " + maxExp + " years";
}

const JobDetails = (props) => {
  const history = useHistory();
  const [jobPosting, setJobPosting] = useState(null);
  const [loading, setLoading] = useState(false);

  let params;
  let id;
  let position;
  
  useEffect(() => {
    let posting = props.location.state;
    params = new URLSearchParams(props.location.search);
    id = params.get("id");
    position = params.get("position");
    if (!id || !position || id === undefined || position === undefined ) {
      history.push("/");
      return;
    }

  

    (async () => {
      setLoading(true);
      try {
        const response = await getJobDetails(id);
        setJobPosting(response.data);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        history.push("/");
      }  
    })();
  }, [id, position]);
  console.log(jobPosting);
  
  return (
    <>
      {loading && (
        <div className={styles.loaderContainer}>
          <Loader />
        </div>
      )}
      <div className={styles.container}>
        <div className={styles.subcontainer}>
          <ul className={styles.breadcrumb}>
            <li>
              <Link to="/">Current Openings</Link>
            </li>
            <li>{jobPosting?.position}</li>
          </ul>

          <div className={styles.job_header}>
            <p className={styles.job_title}>
              {jobPosting?.position && `${jobPosting?.position}`}
            </p>
            <div className={styles.job_desc}>
              <div>
                <p className={styles.jobExp}>
                  {jobPosting &&
                    `Experience : ${expRangeString(
                      jobPosting?.minExp,
                      jobPosting?.maxExp
                    )}`}
                </p>
                <p className={styles.text_muted}>{jobPosting?.locations}</p>
              </div>
              <div id={styles.btn_apply_top}>
                <Link
                  to={{
                    pathname: `/apply`,
                    search: `?id=${jobPosting?.jobPostingId}&position=${jobPosting?.position}`,
                    state: jobPosting,
                  }}
                  className={styles.btn_apply}
                  onClick={markCareersReferral}
                >
                  Apply
                </Link>
              </div>
            </div>
          </div>

          {jobPosting && jobPosting.jobDetails?.length > 0 && (
            <div className={styles.card_style}>
              <div className={styles.card_header}>
                <div>
                  <strong>About the Job</strong>
                </div>{" "}
                <div className={styles.card_badge}>Featured</div>
              </div>

              <div className={styles.card_body}>
                <p>
                  {jobPosting !== null && parse(`${jobPosting.jobDetails}`)}
                </p>
              </div>
            </div>
          )}

          {jobPosting && jobPosting.responsibilities?.length > 0 && (
            <div className={styles.card_style}>
              <div className={styles.card_header}>
                <strong>Core Responsibilities</strong>
              </div>
              <div className={styles.card_body}>
                {jobPosting !== null && parse(jobPosting.responsibilities)}
              </div>
            </div>
          )}

          {jobPosting && jobPosting.prerequisites?.length > 0 && (
            <div className={styles.card_style}>
              <div className={styles.card_header}>
                <strong>Prerequisites</strong>
              </div>
              <div className={styles.card_body}>
                {jobPosting !== null && parse(jobPosting.prerequisites)}
              </div>
            </div>
          )}

          {jobPosting && jobPosting.requiredSkills?.length > 0 && (
            <div className={styles.card_style}>
              <div className={styles.card_header}>
                <strong>Required Skills</strong>
              </div>
              <div className={styles.card_body}>
                {jobPosting !== null && parse(jobPosting.requiredSkills)}
              </div>
            </div>
          )}

          {jobPosting && jobPosting.exposureSkills?.length > 0 && (
            <div className={styles.card_style}>
              <div className={styles.card_header}>
                <strong>Nice to have</strong>
              </div>
              <div className={styles.card_body}>
                {jobPosting !== null && parse(jobPosting.exposureSkills)}
              </div>
            </div>
          )}

          {jobPosting && jobPosting.compensation?.length > 0 && (
            <div className={styles.card_style}>
              <div className={styles.card_header}>
                <strong>Compensation</strong>
              </div>
              <div className={styles.card_body}>
                {jobPosting !== null && parse(jobPosting.compensation)}
              </div>
            </div>
          )}

          {jobPosting && jobPosting.qualifications?.length > 0 && (
            <div className={styles.card_style}>
              <div className={styles.card_header}>
                <strong>Qualifications</strong>
              </div>
              <div className={styles.card_body}>
                {jobPosting !== null && parse(jobPosting.qualifications)}
              </div>
            </div>
          )}

          {jobPosting && (
            <div className={styles.jobApplyButtonBottom}>
              <Link
                id={styles.btnApplyBottom}
                to={{
                  pathname: `/apply`,
                  search: `?id=${jobPosting?.jobPostingId}&position=${jobPosting?.position}`,
                }}
                className={styles.btn_apply}
                onClick={markCareersReferral}
              >
                Apply
              </Link>
            </div>
          )}         
              
       
        </div>
      </div>
    </>
  );
};

export default JobDetails;
